     <div class = "button-container">  <h2 class="page-title animate__animated animate__fadeIn text-center">change password</h2>  </div>
<div>
<form (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading" colCount="6">
    <dxi-item itemType="group" [colCount]="4" [colSpan]="6"> 
      
       <dxi-item dataField="oldpassword" editorType="dxTextBox" colCount="3"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'oldpassword', mode: 'password' }">
      <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
      <dxo-label [visible]="true"></dxo-label>
    </dxi-item>
  
    <dxi-item dataField="newPassword" editorType="dxTextBox" colCount="3"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'newPassword', mode: 'password' }">
      <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
      <dxo-label [visible]="true"></dxo-label>
    </dxi-item>

    <dxi-item dataField="confirmPassword" editorType="dxTextBox" colCount="3"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Confirm Password', mode: 'password' }">
      <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
      <dxi-validation-rule type="custom" message="Passwords do not match" [validationCallback]="confirmPassword">
      </dxi-validation-rule>
      <dxo-label [visible]="true"></dxo-label>
    </dxi-item>
   
    </dxi-item>



         

     <dxi-item itemType="button" [buttonOptions]="buttonOptions"  >
    </dxi-item>

  </dx-form>
</form>




</div>
